export const routeParams = {
  auctionId: ':auctionID',
  mediaState: ':mediaState',
  laneId: ':laneID',
  productId: ':productID',
};

export const dashboardBasePath = '/dashboard';
export const auctionsBasePath = '/auctions';
export const auctionsBreadcrumb = { to: auctionsBasePath, label: 'Auctions' };
export const dashboardBreadcrumb = {
  to: dashboardBasePath,
  label: 'Dashboard',
};

const getPathByKey = ({
  auctionId = null,
  laneId = null,
  productId = null,
  uploadStatus = null,
} = {}) => {
  // **********************************************
  // Routes -- change route path and params here
  // **********************************************

  // const dashboardBasePath = '/dashboard';
  // const auctionsBasePath = '/auctions';
  const auctionPath = `/auction/${routeParams.auctionId}`;
  const mediaPath = `/${routeParams.mediaState}`;
  const auctionMediaPath = `${auctionPath}${mediaPath}`;
  const auctionLanePath = `${auctionPath}/lane/${routeParams.laneId}`;
  const auctionLaneMediaPath = `${auctionLanePath}${mediaPath}`;

  // **********************************************
  // Breadcrumbs -- change to paths go here
  // **********************************************

  const getAuctionIdBreadcrumbPath = (auction) => `/auction/${auction}`;

  // actual breadcrumb nodes

  const auctionProductsBreadcrumb = (auction) => ({
    to: `${getAuctionIdBreadcrumbPath(auction)}/products`,
    label: 'Products',
  });
  const auctionLanesBreadcrumb = (auction) => ({
    to: `${getAuctionIdBreadcrumbPath(auction)}/lanes`,
    label: 'Lanes',
  });

  return {
    root: {
      route: '/',
    },
    login: {
      route: '/login',
    },
    dashboard: {
      route: dashboardBasePath,
      breadcrumbs: [{ label: 'Dashboard' }],
    },
    auctions: {
      route: auctionsBasePath,
      breadcrumbs: [dashboardBreadcrumb, { label: 'Auctions' }],
    },
    auctionTranscriptReport: {
      allAuctions: {
        route: `/auctionTranscriptReport`,
        breadcrumbs: [
          dashboardBreadcrumb,
          auctionsBreadcrumb,
          { label: 'Transcript Report' },
        ],
      },
      singleAuction: {
        route: `${auctionPath}/auctionTranscriptReport`,
        breadcrumbs: [
          dashboardBreadcrumb,
          auctionsBreadcrumb,
          { label: 'Transcript Report' },
        ],
      },
    },
    authorizedMembers: {
      route: `${auctionPath}/authorizedMembers`,
      breadcrumbs: [
        dashboardBreadcrumb,
        auctionsBreadcrumb,
        { label: 'Authorized Members' },
      ],
    },
    registeredMembers: {
      route: `${auctionPath}/members`,
      breadcrumbs: [
        dashboardBreadcrumb,
        auctionsBreadcrumb,
        { label: 'Registered Members' },
      ],
    },
    uniqueMembers: {
      route: `${auctionPath}/uniqueMembers`,
      breadcrumbs: [
        dashboardBreadcrumb,
        auctionsBreadcrumb,
        { label: 'Unique Registered Members' },
      ],
    },
    engineAdmin: {
      route: `/engineAdmin`,
      breadcrumbs: [dashboardBreadcrumb, { label: 'Custom Engine Tools' }],
    },
    auctionLanes: {
      route: `${auctionPath}/lanes`,
      breadcrumbs: [
        dashboardBreadcrumb,
        auctionsBreadcrumb,
        { label: 'Lanes' },
      ],
    },
    proxyBids: {
      route: `${auctionPath}/proxyBids`,
      breadcrumbs: [
        dashboardBreadcrumb,
        auctionsBreadcrumb,
        { label: 'Proxy Bids' },
      ],
    },
    auctionProducts: {
      route: `${auctionPath}/products`,
      breadcrumbs: [
        dashboardBreadcrumb,
        auctionsBreadcrumb,
        { label: 'Products' },
      ],
    },
    auctionMediaStateProducts: {
      route: `${auctionMediaPath}/products`,
      breadcrumbs: [
        dashboardBreadcrumb,
        auctionsBreadcrumb,
        { label: 'Products' },
      ],
    },
    auctionLaneProducts: {
      route: `${auctionLanePath}/products`,
      breadcrumbs: [
        dashboardBreadcrumb,
        auctionsBreadcrumb,
        auctionLanesBreadcrumb(auctionId),
        { label: 'Products' },
      ],
    },
    auctionLaneMediaStateProducts: {
      route: `${auctionLaneMediaPath}/products`,
      breadcrumbs: [
        dashboardBreadcrumb,
        auctionsBreadcrumb,
        auctionLanesBreadcrumb(auctionId),
        { label: 'Products' },
      ],
    },
    auctionProductImages: {
      route: `${auctionPath}/productImages`,
      breadcrumbs: [
        dashboardBreadcrumb,
        auctionsBreadcrumb,
        { label: 'Product Images' },
      ],
    },
    auctionMediaStateProductImages: {
      route: `${auctionMediaPath}/productImages`,
      breadcrumbs: [
        dashboardBreadcrumb,
        auctionsBreadcrumb,
        { label: 'Product Images' },
      ],
    },
    auctionLaneProductImages: {
      route: `${auctionLanePath}/productImages`,
      breadcrumbs: [
        dashboardBreadcrumb,
        auctionsBreadcrumb,
        auctionLanesBreadcrumb(auctionId),
        { label: 'Product Images' },
      ],
    },
    auctionLaneMediaStateProductImages: {
      route: `${auctionLaneMediaPath}/productImages`,
      breadcrumbs: [
        dashboardBreadcrumb,
        auctionsBreadcrumb,
        auctionLanesBreadcrumb(auctionId),
        { label: 'Product Images' },
      ],
    },
    auctionLaneProductDetails: {
      route: `${auctionLanePath}/product/${routeParams.productId}`,
      breadcrumbs: [
        dashboardBreadcrumb,
        auctionsBreadcrumb,
        auctionProductsBreadcrumb(auctionId),
        { label: 'Product Details' },
      ],
    },
  };
};

export const getPath = (
  key,
  {
    auctionId = null,
    laneId = null,
    productId = null,
    uploadStatus = null,
  } = {},
) => {
  const params = { auctionId, laneId, productId, uploadStatus };
  return key ? getPathByKey(params)[key] : getPathByKey(params);
};

export const routePathKeys = Object.keys(getPath());
